var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCategoryReview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 95,
    viewBox: "0 0 94 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0007 16.6844H77.6007M16.0007 78.2844H77.6007M20.4007 3.48438H73.2007M20.0795 11.7872L24.3607 6.65238C25.6587 5.09478 26.3099 4.31598 27.1943 3.89798C28.0831 3.48438 29.0951 3.48438 31.1235 3.48438H62.4779C64.5019 3.48438 65.5183 3.48438 66.4071 3.89798C67.2915 4.31598 67.9427 5.09478 69.2407 6.65238L73.5219 11.7872C75.5415 14.2116 76.5491 15.4216 77.0771 16.8736C77.6007 18.3256 77.6007 19.9052 77.6007 23.0556V71.9132C77.6007 75.0636 77.6007 76.6432 77.0727 78.0952C76.5491 79.5472 75.5415 80.7572 73.5219 83.1816L67.9207 89.9004C67.2695 90.6792 66.9483 91.0708 66.5039 91.2776C66.0639 91.4844 65.5535 91.4844 64.5415 91.4844H29.0599C28.0479 91.4844 27.5419 91.4844 27.0975 91.2776C26.6575 91.0708 26.3319 90.6792 25.6807 89.9004L20.0795 83.1816C18.0599 80.7572 17.0523 79.5472 16.5243 78.0952C16.0007 76.6432 16.0007 75.0636 16.0007 71.9132V23.0556C16.0007 19.9052 16.0007 18.3256 16.5287 16.8736C17.0523 15.4216 18.0599 14.2116 20.0795 11.7872Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8007 58.4844C52.8759 58.4844 57.8007 53.5595 57.8007 47.4844C57.8007 41.4092 52.8759 36.4844 46.8007 36.4844C40.7256 36.4844 35.8007 41.4092 35.8007 47.4844C35.8007 53.5595 40.7256 58.4844 46.8007 58.4844Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryReview);
export default __webpack_public_path__ + "static/media/category-review.3b99f37bb218d1a07161d8e7ef232679.svg";
export { ForwardRef as ReactComponent };